module.exports = __webpack_public_path__ + "static/media/unionIconColor.9c7ab630.svg";